import { render, staticRenderFns } from "./file-archive-component.vue?vue&type=template&id=fb9c76fe&scoped=true"
import script from "./file-archive-component.ts?vue&type=script&lang=ts&external"
export * from "./file-archive-component.ts?vue&type=script&lang=ts&external"
import style0 from "./file-archive-component.scss?vue&type=style&index=0&id=fb9c76fe&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9c76fe",
  null
  
)

export default component.exports